
import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export function useContent<T>(sectionKey: string, initialData: T) {
    const [content, setContent] = useState<T>(initialData);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchContent = async () => {
            try {
                const { data, error } = await supabase
                    .from('site_content')
                    .select('content')
                    .eq('section_key', sectionKey)
                    .maybeSingle();

                if (error) {
                    console.warn(`Could not fetch content for ${sectionKey}:`, error.message);
                } else if (data && data.content) {
                    if (Array.isArray(initialData)) {
                        setContent(data.content);
                    } else {
                        setContent({ ...initialData, ...data.content });
                    }
                } else {
                    // SEEDING LOGIC: If no content found, try to create it with initialData
                    console.log(`Seeding content for ${sectionKey}...`);
                    const { error: insertError } = await supabase
                        .from('site_content')
                        .insert({
                            section_key: sectionKey,
                            content: initialData
                        });

                    if (insertError) {
                        console.error(`Failed to seed content for ${sectionKey}:`, insertError.message);
                    } else {
                        console.log(`Successfully seeded content for ${sectionKey}`);
                    }
                }
            } catch (err) {
                console.error(`Error fetching/seeding ${sectionKey}:`, err);
            } finally {
                setLoading(false);
            }
        };

        fetchContent();
    }, [sectionKey, initialData]);

    return { content, loading };
}
